<template>
	<div style="position: relative; width: 100%; height: 100%;">
		<div id="d008" class="diagram" style="padding-bottom: 3rem;"></div>
		<div
			class="center"
			style="position: absolute; bottom: 0; left: 0; right: 0;"
		>
			<span class="dot primary"></span> {{ 'Nettoomsättning' | T }}
			<span class="dot bcLightGrey"></span> {{ 'Övriga rörelseintäkter' | T }}
			<span v-if="useFinancialResult"
				><span class="dot result"></span> {{ 'Resultat efter finansiella poster' | T }}</span
			>
			<span v-else><span class="dot result"></span> {{ 'Årets resultat' | T }}</span>
		</div>
	</div>
</template>

<script>
/* tslint:disable */
import Highcharts from "highcharts";
import Vue from "vue";
import { colors } from "@/config";

export default {
	name: "D008",
	components: {},
	props: {
		profitloss: Object,
		useFinancialResult: Boolean,
	},

	mounted() {
		this.chart = new Highcharts.chart({
			chart: {
				type: "column",
				renderTo: "d008",
				backgroundColor: "transparent",
			},

			credits: {
				enabled: false,
			},

			title: {
				text: "",
			},

			legend: {
				enabled: false,
			},

			colors: [colors.LightGrey, colors.Primary, colors.Green, colors.Red],

			xAxis: {
				categories: this.profitloss.sheets
					.map((s) => s.DATE_TO.substr(0, 4))
					.reverse(),
				labels: {
					style: { fontSize: "1rem", color: colors.Black, },
				},
			},

			yAxis: {
				opposite: true,
				allowDecimals: false,
				title: {
					text: "",
				},
				labels: {
					formatter() {
						return Vue.options.filters.KR(this.value);
					},
					style: { fontSize: "1rem", color: colors.DarkGrey, },
				},
				tickPixelInterval: 150,
				gridLineColor: colors.LightGrey,
				plotLines: [{
					color: colors.Black,
					width: 2,
					value: 0,
					zIndex: 0,
				}]
			},

			tooltip: {
				formatter: function() {
					return (
						"<b>" + this.series.name + "<br>" + Vue.options.filters.TKR(this.y)
					);
				},
				style: { fontSize: "1.25rem" },
				backgroundColor: colors.Light,
			},

			plotOptions: {
				column: {
					stacking: "normal",
					borderColor: colors.DarkGrey,
				},
			},

			series: [
				{
					name: this.$t("Övriga rörelseintäkter"),
					data: this.profitloss.sheets.map((s) => s.B).reverse(),
					stack: "intakt",
				},
				{
					name: this.$t("Nettoomsättning"),
					data: this.profitloss.sheets
						.map((s, i) =>
							i === 0 ? { y: s.A, color: colors.Secondary } : s.A
						)
						.reverse(),
					stack: "intakt",
				},
				{
					name: this.$t("Årets vinst"),
					data: this.useFinancialResult
						? this.profitloss.sheets.map((s) => (s.N > 0 ? s.N : 0)).reverse()
						: this.profitloss.sheets.map((s) => (s.R > 0 ? s.R : 0)).reverse(),
					stack: "kostnad",
				},
				{
					name: this.$t("Årets förlust"),
					data: this.useFinancialResult
						? this.profitloss.sheets.map((s) => (s.N < 0 ? s.N : 0)).reverse()
						: this.profitloss.sheets.map((s) => (s.R < 0 ? s.R : 0)).reverse(),
					stack: "kostnad",
				},
			],
		});
	},
};
</script>

<style scoped lang="scss">
.dot {
	height: 20px;
	width: 20px;
	border-radius: 50%;
	display: inline-block;
}

.primary {
	background: linear-gradient(
		-45deg,
		get("colors.Secondary"),
		get("colors.Secondary") 50%,
		get("colors.Primary") 50%
	);
	border-radius: 50%;
}

.result {
	background: linear-gradient(
		-45deg,
		col("colors.Negative"),
		col("colors.Negative") 50%,
		col("colors.Positive") 50%
	);
	border-radius: 50%;
}

.center {
	font-size: 1.2rem;
}
</style>
